KXL.module('Components.CommentInput', function (CommentInput, KXL, Backbone, Marionette, $, _) {
	CommentInput.Controller = {
		getCommentInput: function (options) {
			return new CommentInput.View(options);
		}
	};
});
